export default "__VITE_ASSET__C_ScOj8u__"